<template>
    <div class="p-2" style="width:250px">
       <vs-row>
          <vs-col class="mb-3" vs-w="12">
             <validated-input
              :label="$t('GradeControl.Grade')"
              v-validate="'required|numeric'"
              v-model="grade"
              name="grade"
            ></validated-input>
          </vs-col>
       </vs-row>
       <vs-row>
          <vs-col class="mb-3" vs-w="12">
             <validated-input
              :label="$t('GradeControl.Cutoff')"
              v-validate="'required|numeric'"
              v-model="cutOff"
              name="cutOff"
            ></validated-input>
          </vs-col>
       </vs-row>
    </div>
</template>

<script>
import { ValidatedInput } from "./../../../../shared/components";

export default {
  name: 'ForecastResultCellEditor',
  data() {
    return {
      grade: null,
      cutOff: null,
      element: null
    }
  },
  components: {
    ValidatedInput
  },
  created() {
    this.grade = this.$systemUnits.convertGrade(this.params.value.grade, this.params.value.element);
    this.cutOff = this.$systemUnits.convertGrade(this.params.value.cutOff, this.params.value.element);
    this.element = this.params.value.element;
  },
  methods: {
    submitData() {
      this.params.api.stopEditing();
    },
    getValue() {
      const value = {
        grade: this.$systemUnits.convertGradeToMetric(this.grade, this.element),
        cutOff: this.$systemUnits.convertGradeToMetric(this.cutOff, this.element),
        element: this.element
      };

      return value;
    },
    isPopup() {
      return true;
    }
  }
}
</script>
